'use server';

import { redirect } from 'next/navigation';
import { cookies } from 'next/headers';
import { verifyUser } from '@/lib/user';
import { ensureAdminUser } from '@/lib/user';

export async function login(prevState: { error: string | undefined } | null, formData: FormData) {
  await ensureAdminUser();
  
  const email = formData.get('email') as string;
  const password = formData.get('password') as string;

  console.log('[login action] login attempt', {
    email,
    hasPassword: Boolean(password),
  });

  if (!email || !password) {
    console.log('[login action] missing credentials');
    return { error: 'Email and password are required.' };
  }

  try {
    const user = await verifyUser(email, password);

    console.log('[login action] verification result', {
      email,
      userFound: Boolean(user),
    });

    if (!user) {
      return { error: 'Invalid email or password.' };
    }

    // Set session cookie
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000); // 24 hours
    const session = { id: user.id, email: user.email };
    const cookieStore = await cookies();

    cookieStore.set('session', JSON.stringify(session), {
      expires,
      httpOnly: true,
      path: '/',
    });

    console.log('[login action] session cookie set', {
      userId: user.id,
      email: user.email,
      expiresAt: expires.toISOString(),
    });

  } catch (error) {
    console.error('[login action] unexpected error', error);
    return { error: 'An internal error occurred. Please try again.' };
  }

  // Redirect to the dashboard on successful login
  console.log('[login action] redirecting to dashboard');
  redirect('/');
}


export async function logout() {
  // Destroy the session
  const cookieStore = await cookies();
  cookieStore.set('session', '', { expires: new Date(0) });
  console.log('[login action] session cleared via server action logout');
  redirect('/login');
}
